import Vue from 'vue'
import gripUtil from "@/lib/grip.util.js"
import VueAwesomeSwiper from 'vue-awesome-swiper'
import 'swiper/dist/css/swiper.min.css'
import VueWordCloud from 'vuewordcloud'

Vue.config.productionTip = false;
Vue.use(VueAwesomeSwiper, /* { default options with global component } */)
Vue.use(VueWordCloud, )

//금액 콤마 설정 필터 설정
Vue.filter('currency', (val, replace) => {
    if(typeof val !== 'undefined' && !isNaN(val)) {
        return Math.round(val).toLocaleString();
    } else {
        return replace;
    }
});

Vue.filter('separateCurrencyUnit', (number) => {
    return gripUtil.separateCurrencyUnit(number);
});

Vue.filter('formatDate', (val, f) => {
    if(val && val.length >= 8) {
        return gripUtil.stringToDate(val).format(f);
    }
    return "";
});

// 년 월 일 설정
Vue.filter('ymd', (val) => {
    let baseDay = val || '';
    let dayStr = '';

    if(baseDay !== '') {
        baseDay = baseDay.replace(/-/gi, "");
        if(baseDay.length >= 4) {
            dayStr += baseDay.substring(0, 4) + "년 ";
        }

        if(baseDay.length >= 6) {
            dayStr += baseDay.substring(4, 6) + "월 ";
        }

        if(baseDay.length >= 8) {
            dayStr += baseDay.substring(6, 8) + "일";
        }
    }

    return dayStr;
});

//행 개행을 <br>로 변경
Vue.filter('newLineToBr', (val) => {
    if(typeof val !== 'undefined') {

        return val.replace(/&lt;/g, '<').replace(/&gt;/g, '>')
            .replace(/(?:\r\n|\r|\n)\-/g, '<br />&nbsp;&nbsp;&nbsp; - ')
            .replace(/(\r\n|\r|\n)&middot;/gi, '<br />&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; &middot; ')
            .replace(/(\r\n|\r|\n)·/gi, '<br />&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;· ')
            .replace(/(?:\r\n|\r|\n)/g, '<br />');
    } else {
        return "";
    }
});

Vue.filter('unescape', (val) => {
    if(typeof val !== 'undefined') {
        return unescape(val);
    } else {
        return "";
    }
});

//공용 EventBus 추가
(function() {
    let eventBus = new Vue();
    Object.defineProperties(Vue.prototype, {
        $eventBus: {
            get: function () {
                return eventBus;
            }
        }
    });
})();
